module.exports = __webpack_public_path__ + "fonts/HelveticaNeueLTGEO-45Light_0.fb26baa6.otf";